import { Component } from '@angular/core';
import { AppRoutesEnum } from '@shared/enums';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent {
    urls = AppRoutesEnum;

    openChat(): void {}
}
